module.exports = __webpack_public_path__ + "static/Beetroot-&-Feta-20cc4f955861ece3f3b997bce76bf5fc.png";